/* Zolah Theme – ohne Bibliotheken, ca. 6 KB. Warenkorb-Schublade (Ajax), Galerie, Menge, Sticky-Kauf, Routine. */
(function () {
  const S = window.skv || { routes: {}, moneyFormat: '{{amount_with_comma_separator}} €', freeShipping: 0 };
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  function geld(cents) {
    const v = (cents / 100).toFixed(2);
    const komma = v.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return S.moneyFormat.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, komma).replace(/\{\{\s*amount\s*\}\}/, v);
  }
  async function json(url, opts) {
    const r = await fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}));
    const d = await r.json();
    if (!r.ok) throw new Error(d.description || d.message || 'Fehler');
    return d;
  }

  /* ---------- Warenkorb-Schublade ---------- */
  const lade = $('[data-schublade]');
  function oeffnen() { if (!lade) return; lade.classList.add('offen'); lade.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; const k = $('[data-schliessen]', lade); k && k.focus(); }
  function schliessen() { if (!lade) return; lade.classList.remove('offen'); lade.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  document.addEventListener('keydown', e => { if (e.key === 'Escape') schliessen(); });
  $$('[data-schliessen]').forEach(b => b.addEventListener('click', schliessen));
  $$('[data-warenkorb-oeffnen]').forEach(a => a.addEventListener('click', e => { if (!lade) return; e.preventDefault(); zeichnen().then(oeffnen); }));

  function zaehler(n) { $$('[data-zaehler]').forEach(z => { z.textContent = n; z.hidden = n === 0; }); }

  async function zeichnen() {
    if (!lade) return;
    const c = await json(S.routes.cart + '.js');
    zaehler(c.item_count);
    const inhalt = $('[data-inhalt]', lade), fuss = $('[data-fuss]', lade);
    if (!c.item_count) {
      inhalt.innerHTML = '<div class="leer"><p>Dein Warenkorb ist noch leer.</p><a class="knopf" href="' + S.routes.root + 'collections/all">Jetzt entdecken</a></div>';
      fuss.hidden = true; return;
    }
    let html = '';
    const upEl = $('[data-upsell]'), up = upEl ? JSON.parse(upEl.textContent) : null;
    const anzahl = up ? c.items.filter(it => it.product_id === up.id).reduce((n, it) => n + it.quantity, 0) : 0;
    if (up) {
      const pz = Math.min(100, Math.round(Math.min(anzahl, 3) / 3 * 100)), rest = 3 - anzahl;
      const text = rest > 0 ? 'Noch <b>' + rest + ' Mütze' + (rest > 1 ? 'n' : '') + '</b> – dann ist eine <b>gratis</b>!' : '<b>🎁 2 + 1 Gratis freigeschaltet!</b>';
      html += '<div class="wk-stufen"><p>' + text + '</p><div class="wk-stufen__leiste"><span style="width:' + pz + '%"></span>' +
        '<i class="wk-stufen__punkt' + (anzahl >= 1 ? ' an' : '') + '" style="left:33.3%">🚚</i><i class="wk-stufen__punkt' + (anzahl >= 3 ? ' an' : '') + '" style="left:100%">🎁</i></div>' +
        '<div class="wk-stufen__texte"><span style="left:33.3%">Gratis-Versand</span><span style="left:100%">2 + 1 Gratis</span></div></div>';
    }
    c.items.forEach((it, i) => {
      const bild = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      html += '<div class="position"><img src="' + bild + '" alt="" width="84" height="84" loading="lazy">' +
        '<div class="position__info"><a class="position__titel" href="' + it.url + '">' + it.product_title + '</a>' +
        (it.variant_title ? '<span class="hinweis-klein">' + it.variant_title + '</span>' : '') +
        '<div class="position__zeile"><div class="menge"><button type="button" aria-label="Weniger" data-menge="' + (i + 1) + '" data-wert="' + (it.quantity - 1) + '">−</button><input value="' + it.quantity + '" readonly aria-label="Menge"><button type="button" aria-label="Mehr" data-menge="' + (i + 1) + '" data-wert="' + (it.quantity + 1) + '">+</button></div>' +
        '<span class="preis"><b>' + geld(it.final_line_price) + '</b>' + (it.original_line_price > it.final_line_price ? '<s>' + geld(it.original_line_price) + '</s>' : '') + '</span></div>' +
        '<button type="button" class="entfernen" data-menge="' + (i + 1) + '" data-wert="0">Entfernen</button></div></div>';
    });
    if (up) {
      const imWk = c.items.map(it => it.variant_id);
      const vorschlag = up.varianten.filter(v => v.frei && imWk.indexOf(v.id) === -1).slice(0, 3);
      if (vorschlag.length) {
        html += '<div class="wk-upsell"><h3>' + (anzahl > 0 && anzahl < 3 ? 'Noch eine Farbe dazu?' : 'Wird oft mitgekauft') + '</h3>' + vorschlag.map(v =>
          '<div class="wk-upsell__karte"><img src="' + v.bild + '" alt="" width="64" height="64" loading="lazy"><div><b>' + up.titel + '</b><span>' + v.name + '</span><span class="preis"><b>' + geld(v.preis) + '</b>' + (v.vgl > v.preis ? '<s>' + geld(v.vgl) + '</s>' : '') + '</span></div><button type="button" class="knopf" data-upsell-id="' + v.id + '">+ Hinzufügen</button></div>').join('') + '</div>';
      }
    }
    inhalt.innerHTML = html;
    $$('[data-upsell-id]', inhalt).forEach(b => b.addEventListener('click', () => hinzufuegen([{ id: +b.dataset.upsellId, quantity: 1 }], b)));
    const zeilen = {};
    c.items.forEach(it => (it.line_level_discount_allocations || []).forEach(a => { const t = a.discount_application.title; zeilen[t] = (zeilen[t] || 0) + a.amount; }));
    const rab = Object.keys(zeilen).map(t => '<div class="summe wk-rabatt"><span>' + t + '</span><span>−' + geld(zeilen[t]) + '</span></div>').join('') +
      (c.cart_level_discount_applications || []).map(d => '<div class="summe wk-rabatt"><span>Rabatt · ' + d.title + '</span><span>−' + geld(d.total_allocated_amount) + '</span></div>').join('');
    $('[data-rabatte]', lade).innerHTML = rab;
    $('[data-zwischensumme]', lade).textContent = geld(c.original_total_price);
    $('[data-gesamt]', lade).textContent = geld(c.total_price);
    fuss.hidden = false;
    $$('[data-menge]', inhalt).forEach(b => b.addEventListener('click', async () => {
      b.disabled = true;
      await json(S.routes.cartChange, { method: 'POST', body: JSON.stringify({ line: +b.dataset.menge, quantity: Math.max(0, +b.dataset.wert) }) });
      zeichnen();
    }));
  }

  async function hinzufuegen(items, knopf) {
    const text = knopf ? knopf.innerHTML : '';
    if (knopf) { knopf.disabled = true; knopf.textContent = 'Wird hinzugefügt …'; }
    try {
      await json(S.routes.cartAdd, { method: 'POST', body: JSON.stringify({ items: items }) });
      if (lade) { await zeichnen(); oeffnen(); }
      else if (S.cartApp) {
        // Fremde Warenkorb-App (z. B. UpCart): Zähler aktualisieren und App benachrichtigen
        const c = await json(S.routes.cart + '.js'); zaehler(c.item_count);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        if (knopf) { knopf.textContent = 'Im Warenkorb ✓'; await new Promise(r => setTimeout(r, 1400)); }
      }
      else { location.href = S.routes.cart; }
    } catch (e) { alertFehler(knopf, e.message); }
    if (knopf) { knopf.disabled = false; knopf.innerHTML = text; }
  }
  function alertFehler(knopf, msg) {
    const m = document.createElement('p'); m.className = 'meldung meldung--fehler'; m.textContent = msg;
    knopf && knopf.parentElement.after(m); setTimeout(() => m.remove(), 5000);
  }

  // Produkt-Formulare (Produktseite, Karten, Sticky)
  document.addEventListener('submit', e => {
    const f = e.target.closest('form[data-kauf-formular]');
    if (!f || !lade) return;
    e.preventDefault();
    if (f.dataset.items) {
      const liste = JSON.parse(f.dataset.items), sum = {};
      liste.forEach(i => { sum[i] = (sum[i] || 0) + 1; });
      if (liste.length) { hinzufuegen(Object.keys(sum).map(i => ({ id: +i, quantity: sum[i] })), f.querySelector('[type="submit"]')); return; }
    }
    const id = f.querySelector('[name="id"]').value;
    const q = +(f.querySelector('[name="quantity"]') || { value: 1 }).value || 1;
    hinzufuegen([{ id: +id, quantity: q }], f.querySelector('[type="submit"]'));
  });

  // Routine: mehrere Produkte auf einmal
  $$('[data-routine-kaufen]').forEach(b => b.addEventListener('click', () => {
    const ids = JSON.parse(b.dataset.routineKaufen || '[]').map(id => ({ id: id, quantity: 1 }));
    hinzufuegen(ids, b);
  }));

  // Rabattcode in der Schublade
  const rabForm = $('[data-rabatt-form]');
  rabForm && rabForm.addEventListener('submit', async e => {
    e.preventDefault();
    const code = rabForm.code.value.trim();
    if (!code) return;
    try {
      const c = await json(S.routes.cartUpdate, { method: 'POST', body: JSON.stringify({ discount: code }) });
      const treffer = (c.discount_codes || []).find(d => d.code.toLowerCase() === code.toLowerCase());
      if (treffer && !treffer.applicable) {
        // nur den ungültigen Code wieder entfernen, gültige Codes bleiben
        const gueltig = (c.discount_codes || []).filter(d => d.applicable).map(d => d.code).join(',');
        await json(S.routes.cartUpdate, { method: 'POST', body: JSON.stringify({ discount: gueltig }) });
        throw new Error('ungueltig');
      }
      await zeichnen(); rabForm.code.value = '';
    }
    catch (err) { alertFehler(rabForm.querySelector('button'), 'Dieser Code ist leider nicht gültig.'); }
  });

  /* ---------- Menge auf der Produktseite ---------- */
  $$('[data-mengen-feld]').forEach(w => {
    const inp = $('input', w);
    $$('button', w).forEach(b => b.addEventListener('click', () => { inp.value = Math.max(1, (+inp.value || 1) + (+b.dataset.schritt)); }));
  });

  /* ---------- Galerie (berücksichtigt ausgeblendete Bilder je Farbe) ---------- */
  const sichtbar = g => $$('.galerie__folie', g).filter(f => f.style.display !== 'none');
  const hinScrollen = (g, f) => { const spur = $('.galerie__spur', g); spur.scrollTo({ left: f.offsetLeft - spur.offsetLeft, behavior: 'smooth' }); };
  $$('[data-galerie]').forEach(g => {
    const spur = $('.galerie__spur', g);
    if (!spur) return;
    const setze = () => {
      const fs = sichtbar(g), i = Math.round(spur.scrollLeft / spur.clientWidth), akt = fs[i];
      $$('.galerie__mini button', g).forEach(m => m.classList.toggle('aktiv', akt && m.dataset.miniMedia === akt.dataset.mediaId));
      $$('.galerie__punkte span', g).forEach((p, k) => { p.style.display = k < fs.length ? '' : 'none'; p.classList.toggle('aktiv', k === i); });
    };
    spur.addEventListener('scroll', setze, { passive: true });
    $$('.galerie__mini button', g).forEach(m => m.addEventListener('click', () => {
      const f = $('.galerie__folie[data-media-id="' + m.dataset.miniMedia + '"]', g); f && hinScrollen(g, f);
    }));
    setTimeout(setze, 50);
  });
  $$('[data-galerie-schritt]').forEach(b => b.addEventListener('click', () => {
    const g = b.closest('[data-galerie]'), spur = $('.galerie__spur', g), fs = sichtbar(g), n = fs.length;
    if (!n) return;
    const i = Math.round(spur.scrollLeft / spur.clientWidth) + Number(b.dataset.galerieSchritt);
    hinScrollen(g, fs[(i + n) % n]);
  }));

  /* ---------- Bild-Zoom ---------- */
  const folien = $$('[data-zoom]');
  if (folien.length) {
    const z = document.createElement('div');
    z.className = 'zoom'; z.setAttribute('role', 'dialog'); z.setAttribute('aria-modal', 'true'); z.setAttribute('aria-label', 'Bildansicht');
    const pfeil = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    z.innerHTML = '<img alt="">' + '<button class="zoom__zu" aria-label="Schließen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' + (folien.length > 1 ? '<button class="zoom__zurueck" aria-label="Vorheriges Bild">' + pfeil + '</button><button class="zoom__vor" aria-label="Nächstes Bild">' + pfeil + '</button>' : '');
    document.body.appendChild(z);
    let akt = 0, startX = null;
    const bild = $('img', z);
    const zeige = i => { akt = (i + folien.length) % folien.length; bild.src = folien[akt].dataset.zoom; };
    const auf = i => { zeige(i); z.classList.add('offen'); document.body.style.overflow = 'hidden'; $('.zoom__zu', z).focus(); };
    const zu = () => { z.classList.remove('offen'); document.body.style.overflow = ''; };
    folien.forEach((f, i) => {
      f.addEventListener('click', () => auf(i));
      f.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); auf(i); } });
    });
    $('.zoom__zu', z).addEventListener('click', zu);
    z.addEventListener('click', e => { if (e.target === z || e.target === bild) zu(); });
    const zur = $('.zoom__zurueck', z), vor = $('.zoom__vor', z);
    zur && zur.addEventListener('click', () => zeige(akt - 1));
    vor && vor.addEventListener('click', () => zeige(akt + 1));
    z.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    z.addEventListener('touchend', e => { if (startX === null) return; const d = e.changedTouches[0].clientX - startX; if (Math.abs(d) > 50) zeige(akt + (d < 0 ? 1 : -1)); startX = null; });
    document.addEventListener('keydown', e => { if (!z.classList.contains('offen')) return; if (e.key === 'Escape') zu(); if (e.key === 'ArrowRight') zeige(akt + 1); if (e.key === 'ArrowLeft') zeige(akt - 1); });
  }

  /* ---------- Bewertungen: alle anzeigen ---------- */
  $$('[data-mehr-knopf]').forEach(k => k.addEventListener('click', () => {
    const l = $('[data-mehr-liste]', k.closest('section')); l && l.classList.add('alle'); k.remove();
  }));

  /* ---------- Newsletter: Code anzeigen, kopieren, im Warenkorb hinterlegen ---------- */
  $$('[data-code-einloesen]').forEach(box => {
    const code = box.dataset.codeEinloesen;
    json(S.routes.cartUpdate, { method: 'POST', body: JSON.stringify({ discount: code }) }).catch(() => {});
    box.scrollIntoView({ block: 'center' });
  });
  $$('[data-code-kopieren]').forEach(b => b.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(b.dataset.codeKopieren); b.textContent = 'Kopiert ✓'; } catch (e) { b.textContent = b.dataset.codeKopieren; }
  }));

  /* ---------- Titel-Video: Vorschaubild sofort, Video lädt parallel und startet sofort ---------- */
  const starteVideos = () => $$('video[data-video-quelle]').forEach(v => {
    if (!v.dataset.videoQuelle || v.src) return;
    v.src = v.dataset.videoQuelle; v.muted = true;
    const p = v.play(); p && p.catch(() => {});
  });
  // sofort starten, sobald die Seite aufgebaut ist (nicht auf langsame Apps warten)
  starteVideos();

  /* ---------- Sticky-Kauf ---------- */
  const sticky = $('[data-sticky-kauf]'), haupt = $('[data-haupt-kauf]');
  if (sticky && haupt && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => sticky.classList.toggle('sichtbar', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(haupt);
  }

  /* ---------- Varianten ---------- */
  $$('[data-varianten]').forEach(sel => sel.addEventListener('change', () => {
    const f = sel.closest('form'); f.querySelector('[name="id"]').value = sel.value;
  }));
})();
